module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.library.js
// module id = 442
// module chunks = 0